"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const button_1 = require("../button");
const form_radio_1 = require("../form-radio");
const theme_1 = require("../theme");
const disqualify_styled_1 = require("./disqualify.styled");
var TravelNestSignUpReason;
(function (TravelNestSignUpReason) {
    TravelNestSignUpReason["PROPERTY_OWNER"] = "propertyOwner";
    TravelNestSignUpReason["PROPERTY_MANAGER"] = "propertyManager";
})(TravelNestSignUpReason || (TravelNestSignUpReason = {}));
exports.Disqualify = ({ onSubmit }) => {
    const [reason, setReason] = react_1.useState('');
    return React.createElement(disqualify_styled_1.default, null,
        React.createElement("form", { className: "disqualify", onSubmit: (e) => {
                e.preventDefault();
                if (reason) {
                    onSubmit();
                }
            } },
            React.createElement("label", { className: "disqualify__label", htmlFor: "signupReason" }, "TravelNest advertises holiday lets on multiple channels."),
            React.createElement("div", { className: "disqualify__row" },
                React.createElement(form_radio_1.FormRadio, { name: 'signupReason', value: TravelNestSignUpReason.PROPERTY_OWNER, checked: reason === TravelNestSignUpReason.PROPERTY_OWNER, onChange: (e) => e.currentTarget.checked && setReason(TravelNestSignUpReason.PROPERTY_OWNER), label: 'I own a holiday let' })),
            React.createElement("div", { className: "disqualify__row" },
                React.createElement(form_radio_1.FormRadio, { name: 'signupReason', value: TravelNestSignUpReason.PROPERTY_MANAGER, checked: reason === TravelNestSignUpReason.PROPERTY_MANAGER, onChange: (e) => e.currentTarget.checked && setReason(TravelNestSignUpReason.PROPERTY_MANAGER), label: 'I manage a holiday let' })),
            React.createElement("div", { className: "disqualify__row" },
                React.createElement(button_1.default, { disabled: !reason, bgColor: theme_1.default.colours.primary.default, color: theme_1.default.colours.text.lightest }, "Next"))));
};
//# sourceMappingURL=Disqualify.js.map